import { env } from "../../config/env";

export const wordpressBaseUrls = [
  env.wordpressApiBaseUrl,
  env.wordpressApiFallbackUrl,
].filter(Boolean);

export const wordpressEndpoints = {
  posts: ["/posts"],
  postBySlug: ["/posts"],
  pages: ["/pages"],
  pageBySlug: ["/pages"],
  categories: ["/categories"],
  tags: ["/tags"],
  apps: ["/apps", "/projects"],
  appBySlug: ["/apps", "/projects"],
  siteSettings: ["/site-settings", "/settings"],
  navigation: ["/site-navigation"],
};
